// Content inside translated sentences (doc/20261023-i18n-zh-cn.md §3.1). The content-safe `Trans` escapes each value
// before react-i18next parses the sentence, and react-i18next interpolates the parsed text once more before it
// unescapes it. Braces are escaped too, so a value holding `{{name}}` is never read as a placeholder in that second
// pass: content is interpolated once and shown as it is.

const ESCAPES = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;', '/': '&#x2F;', '{': '&#123;', '}': '&#125;' };

/** i18next's `interpolation.escape`: used only where a call asks for escaping, which the content-safe Trans does. */
export function escapeContent(value) {
  return String(value).replace(/[&<>"'/{}]/gu, (character) => ESCAPES[character]);
}

const ENTITIES = {
  '&amp;': '&', '&#38;': '&', '&lt;': '<', '&#60;': '<', '&gt;': '>', '&#62;': '>', '&apos;': "'", '&#39;': "'",
  '&quot;': '"', '&#34;': '"', '&nbsp;': ' ', '&#160;': ' ', '&copy;': '©', '&#169;': '©', '&reg;': '®',
  '&#174;': '®', '&hellip;': '…', '&#8230;': '…', '&#x2F;': '/', '&#47;': '/', '&#123;': '{', '&#125;': '}',
};

/** react-i18next's `unescape`: its own entities, plus the braces `escapeContent` adds. */
export function unescapeContent(text) {
  return text.replace(/&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47|#123|#125);/gu,
    (entity) => ENTITIES[entity]);
}
